let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kiGNy"), load("ivNGg")]).then(() => parcelRequire('6gH5T'));